<!--
=========================================================================================
    Description: Unify Communication Center
    This module can bring forth super convenient to user to manage their all communication channels here.
==========================================================================================
-->

<template>
  <div id="dev-component">
    Communication Center: { Subscription ID }

    <div v-if="development.active" class="in-page-devtool">
      <div class="flex flex-inline justify-between">
        <div class="flex items-center h-8" @click="development.devtool = !development.devtool">
          <feather-icon icon="HexagonIcon" class="text-grey mr-2" :svgClasses="[{ 'text-success': development.devtool },'h-6 w-6']"></feather-icon>
          <h5>Development Mode</h5>
        </div>
      </div>
          
      <div v-if="development.devtool">
        <button @click="development.example = !development.example">Example</button>
        Selected Panel: {{ localData.selectedPanel }}
        <button @click="localData.isLeftSidebarActive = !localData.isLeftSidebarActive">Left Sidebar</button>
        <button @click="localData.isMessageContentActive = !localData.isMessageContentActive">Content Pane</button>
      </div>
    </div>
          
    <component :is="'production'" :dev="development.active" v-bind="{ devData }" />
          
    <Example v-if="development.active && development.example === true" />
          
    <div v-if="development.active && development.showAllMessages">
      {{ localData.messagePool }}
    </div>
  </div>  
</template>
          
<script>  
import { state } from "./data";
          
export default {
  components: {
    Production: () => import("./index"),
    Example:() => import("./example"),
  },      
  data() {
    return {
      development: {
        active            : true,
        example           : true,
        devtool           : true,
      },  
      localData: state.local,
      devData: {
          
      }   
    }     
  },      
  methods: {
    closeMessageContentView() {
      this.localData.isMessageContentActive = false;
    },    
  },      
  mounted() {
    const mockMessages = [
      {   
        'type': "pm",
        'id': 'pm-new-test-1',
        'subject': 'Test New Private Message',
        'sender_name': "Developer",
        'unread': true,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
      {   
        'type': "pm",
        'id': 'pm-new-test-2',
        'subject': 'Test New Private Message',
        'sender_name': "Developer",
        'unread': false,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
      {   
        'type': "chat",
        'id': 'chat-new-test-1',
        'subject': 'Test New Chat Message',
        'sender_name': "Developer",
        'unread': false,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
      {   
        'type': "chat",
        'id': 'chat-new-test-2',
        'subject': 'Test New Chat Message',
        'sender_name': "Developer",
        'unread': true,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
      {   
        'type': "webboard",
        'id': 'webboard-new-test-1',
        'subject': 'Test New Webboard Reply Message',
        'sender_name': "Developer",
        'unread': true,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
      {   
        'type': "webboard",
        'id': 'webboard-new-test-2',
        'subject': 'Test New Webboard Reply Message',
        'sender_name': "Developer",
        'unread': true,
        'time': new Date(),
        'isStarred': true,
        'content': "This is just a testing"
      },  
    ];    
    for (let message of mockMessages) {
      const pool = this.localData.messagePool[message.type];
      if (pool && pool.findIndex(m => m.id === message.id) < 0) {
        this.localData.messagePool[message.type].unshift(message)
      }   
    }     
  }       
}         
</script> 
          
<style lang="scss">
@import "./communication.scss";
          
#communication-comp {
  min-height: 60vh;
  position: relative;
  border-top: solid 1px lightgray;
}         
</style>  
          